"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var _router = require("@reach/router");

var _focusTrapReact = _interopRequireDefault(require("focus-trap-react"));

var _reactFeather = require("react-feather");

var _i18n = require("@lce/i18n");

var Styled = _interopRequireWildcard(require("./EmptyCartWarningModal.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var EmptyCartWarningModal = function EmptyCartWarningModal(_a) {
  var href = _a.href,
      props = (0, _tslib.__rest)(_a, ["href"]);
  var t = (0, _i18n.useTranslation)().t;
  return React.createElement(_slice.Layer, (0, _tslib.__assign)({}, props, {
    lockBodyScroll: true
  }), React.createElement(_focusTrapReact["default"], {
    active: props.isOpen
  }, React.createElement(Styled.ModalBox, {
    "aria-labelledby": "empty-cart-warning__heading",
    "aria-modal": "true",
    role: "dialog"
  }, React.createElement(_slice.Flex, {
    justifyContent: "space-between",
    p: 5,
    width: 1
  }, React.createElement(_slice.Heading, {
    as: "h2",
    "data-testid": "empty-cart-warning__heading",
    fontSize: 6,
    m: 0
  }, t('Common.Continue')), React.createElement(_slice.Anchor, {
    "aria-label": "close",
    as: "button",
    color: "#959595",
    "data-testid": "empty-cart-warning__close-button",
    onClick: props.onClose
  }, React.createElement(_reactFeather.XCircle, null))), React.createElement(_slice.Box, {
    p: 5,
    pt: 0
  }, React.createElement(_slice.Text, {
    "data-testid": "empty-cart-warning__body-line1"
  }, t('Header.Cart.EmptyWarning.Cart Emptied Label')), React.createElement(_slice.Text, {
    "data-testid": "empty-cart-warning__body-line2",
    mb: 4
  }, t('Header.Cart.EmptyWarning.Continue Label')), React.createElement(_slice.Flex, null, React.createElement(_slice.Box, null, React.createElement(_slice.Button, {
    "data-testid": "empty-cart-warning__continue-button",
    onClick: function onClick() {
      return (0, _router.navigate)(href);
    }
  }, t('Common.Continue'))))))));
};

var _default = EmptyCartWarningModal;
exports["default"] = _default;